import NovedadesRetenidasPage from './NovedadesRetenidasPage.jsx';

export default function NovedadesGuiaSinEntregarCargaRetenida() {
  return <NovedadesRetenidasPage />;
}
